import type { UserTeam } from '@skop-app/lib-domain/types'

import { isPersonalWorkspaceMembership } from '@/features/team-selection'
import type { OrganizationScope } from '@/utils/organization'

type ResolvePersonalWorkspaceOrganizationIdParams = {
  organizationScope: OrganizationScope
  teams: UserTeam[]
}

export const resolvePersonalWorkspaceOrganizationId = ({
  organizationScope,
  teams,
}: ResolvePersonalWorkspaceOrganizationIdParams): string | undefined => {
  const soloMemberships = teams.filter(isPersonalWorkspaceMembership)

  const selectedOrganizationId = organizationScope.selectedOrganizationId
  const isSelectedSoloMembership = soloMemberships.some(
    (membership) => membership.value === selectedOrganizationId,
  )
  if (selectedOrganizationId != null && isSelectedSoloMembership) {
    return selectedOrganizationId
  }

  const activeOrganizationId = organizationScope.activeOrganizationId
  const activeSoloMembership = soloMemberships.find(
    (membership) => membership.value === activeOrganizationId,
  )
  if (activeOrganizationId != null && activeSoloMembership?.value) {
    return activeSoloMembership.value
  }

  if (
    (organizationScope.scopeKind === 'solo' ||
      organizationScope.scopeKind === 'unresolved') &&
    soloMemberships.length === 1
  ) {
    return soloMemberships[0]?.value
  }

  return undefined
}
